import React, { Component } from 'react';
import PropTypes from 'prop-types';




import { connect } from 'react-redux';
import { getUser } from '../../redux/selectors/AppSelectors';
import { fetchFormBaseFilters, fetchLeadFormData } from '../../redux/actions/LeadActions';
import { getLeadFormData } from '../../redux/selectors/LeadSelectors';
import Header from '../leads/LeadForm/SliderForm/components/Header';

class CityTriggerSlide extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentSlide: {},
      selectedValues: [],
      showNextBtn: true,
      showPrevBtn: false,
      isLastBtn: false,
      currentIndex: 0,
      mainOccasions: [
        {
          label: 'Kid\'s Birthday',
          value: 'Kids Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/birthday-party.png',
          altText: 'birthday-party',
        },
        {
          label: 'Team Party',
          value: 'Corporate Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/team-party.png',
          altText: 'team-party',
        },
        {
          label: 'Wedding',
          value: 'Wedding',
          img: 'https://cdn.venuemonk.com/images/sliderform/wedding.png',
          altText: 'wedding',
        },
        {
          label: 'Cocktail Party',
          value: 'Cocktail Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'cocktail-party',
        },
        {
          label: 'Corporate Events',
          value: 'Conference',
          img: 'https://cdn.venuemonk.com/images/sliderform/conference.png',
          altText: 'conference',
        },
        {
          label: 'Engagement',
          value: 'Engagement',
          img: 'https://cdn.venuemonk.com/images/sliderform/engagement.png',
          altText: 'engagement',
        },
      ],
    };
  }

  componentDidMount() {
    this.props.dispatch(fetchFormBaseFilters());
    this.props.dispatch(fetchLeadFormData());
    this.setState({currentSlide: this.props.leadFormData.slides && this.props.leadFormData.slides.length > 0 ? this.props.leadFormData.slides[0]: []});
  }

  handleClick = (item, value) => {
  };

  render() {
    return (
      <div className="">
        <Header
          title={`Let's Plan Your Event`}
        />
        <div style={{ height: '100%' }}>
          <div style={{ height: `350px`, overflowX: 'hidden', overflowY: 'scroll' }}>
            <div>
              <div className="">
                {this.state.mainOccasions.map(item => (
                  <div
                    key={item.value}
                    className={item.isSelected ? `col-lg-4 col-xs-6 col-sm-6 btn vm-slider-btn occasion-slide vme-o-div active` :
                      `col-lg-4 col-xs-6 col-sm-6 btn vm-slider-btn occasion-slide vme-o-div`}
                    onClick={() => item.isSelected ? null : this.handleClick('occasion', item.value)}
                  >
                    <img className="sliderForm-img vme-o-img" src={item.img} alt={item.altText}/>
                    <div className="text-center vme-o-txt">{item.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    leadFormData: getLeadFormData(state),
  };
}

CityTriggerSlide.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

CityTriggerSlide.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(CityTriggerSlide);

